import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "open"];

/** @jsx jsx */
import { colors } from '@flowio/react-theme';
import { css, jsx } from '@emotion/react';
import { Dialog } from '@flowio/react-dialog';
import { rgba } from 'polished';
import React from 'react';
var styles = /*#__PURE__*/css({
  width: '800px',
  paddingTop: '0',
  boxShadow: "0 2px 8px 0 ".concat(rgba(colors.GRAY_900, 0.20))
}, process.env.NODE_ENV === "production" ? "" : ";label:styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1dvcmtzaGVldC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBU2UiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvV29ya3NoZWV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuXG5pbXBvcnQgeyBjb2xvcnMgfSBmcm9tICdAZmxvd2lvL3JlYWN0LXRoZW1lJztcbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgRGlhbG9nIH0gZnJvbSAnQGZsb3dpby9yZWFjdC1kaWFsb2cnO1xuaW1wb3J0IHsgcmdiYSB9IGZyb20gJ3BvbGlzaGVkJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgdHlwZSB7IFdvcmtzaGVldFByb3BzIH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5jb25zdCBzdHlsZXMgPSBjc3Moe1xuICB3aWR0aDogJzgwMHB4JyxcbiAgcGFkZGluZ1RvcDogJzAnLFxuICBib3hTaGFkb3c6IGAwIDJweCA4cHggMCAke3JnYmEoY29sb3JzLkdSQVlfOTAwLCAwLjIwKX1gLFxufSk7XG5cbmNvbnN0IFdvcmtzaGVldDogUmVhY3QuRkM8V29ya3NoZWV0UHJvcHM+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIG9wZW4gPSBmYWxzZSxcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pOiBSZWFjdC5SZWFjdEVsZW1lbnQgPT4gKFxuICA8RGlhbG9nXG4gICAgey4uLnVuaGFuZGxlZFByb3BzfVxuICAgIGNzcz17c3R5bGVzfVxuICAgIG9wZW49e29wZW59XG4gICAgYmFja2Ryb3BcbiAgICBzY3JvbGxhYmxlPlxuICAgIHtjaGlsZHJlbn1cbiAgPC9EaWFsb2c+XG4pO1xuXG5Xb3Jrc2hlZXQuZGlzcGxheU5hbWUgPSAnV29ya3NoZWV0JztcblxuZXhwb3J0IGRlZmF1bHQgV29ya3NoZWV0O1xuIl19 */");

var Worksheet = function Worksheet(_ref) {
  var children = _ref.children,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx(Dialog, _extends({}, unhandledProps, {
    css: styles,
    open: open,
    backdrop: true,
    scrollable: true
  }), children);
};

Worksheet.displayName = 'Worksheet';
export default Worksheet;